var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPositive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 6.66667H6.66667V10.8333C6.66667 11.2917 6.29167 11.6667 5.83333 11.6667C5.375 11.6667 5 11.2917 5 10.8333V6.66667H0.833333C0.375 6.66667 0 6.29167 0 5.83333C0 5.375 0.375 5 0.833333 5H5V0.833333C5 0.375 5.375 0 5.83333 0C6.29167 0 6.66667 0.375 6.66667 0.833333V5H10.8333C11.2917 5 11.6667 5.375 11.6667 5.83333C11.6667 6.29167 11.2917 6.66667 10.8333 6.66667Z",
    fill: "#64748B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositive);
export default __webpack_public_path__ + "static/media/positive.6fbe5e8867cef2769fe8598a1a7951d8.svg";
export { ForwardRef as ReactComponent };